import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'wowjs/css/libs/animate.css'
import './axios'
import './axios/router'
import '@vant/touch-emulator';
import { WOW } from "wowjs";
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// Viewer.setDefaults({
//   Options: { 'inline': true, 'button': false, 'navbar': false, 'title': false, 'toolbar': false, 'tooltip': false, 'movable': false, 'zoomable': false, 'rotatable': false, 'scalable': false, 'transition': false, 'fullscreen': false, 'keyboard': false, 'url': 'data-source' }
// })
// Vue.use(Viewer)

Vue.use(Vant);
//引入vconsole
if(process.env.NODE_ENV !== 'production'){
  // require('./assets/js/vconsole')
}
Vue.prototype.$wow = function (WOWClass) {
  var wow = new WOW({
    boxClass: WOWClass,
    animateClass: "animated",
    offset: -1000,
    mobile: true
  });
  wow.init();
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
